import { render } from "./AttributeTitle.vue?vue&type=template&id=4ab2b695"
import script from "./AttributeTitle.vue?vue&type=script&lang=js"
export * from "./AttributeTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__